import React from "react";
import { IconProps } from "./IconProps";

const Pinned: React.FC<IconProps> = ({
    size = 20,
    color = "#F7F9F9",
    ...props
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 20 20"
            fill="none"
            {...props}
        >
            <path
                d="M9.93277 12.5L9.93277 18.3333M6.59944 6.09007V7.86558C6.59944 8.03893 6.59944 8.12561 6.58242 8.20851C6.56733 8.28206 6.54236 8.35324 6.5082 8.4201C6.4697 8.49547 6.41555 8.56315 6.30726 8.69851L4.99911 10.3337C4.44433 11.0272 4.16694 11.3739 4.16663 11.6657C4.16635 11.9195 4.28174 12.1596 4.48008 12.3179C4.70815 12.5 5.15219 12.5 6.04027 12.5H13.8253C14.7134 12.5 15.1574 12.5 15.3855 12.3179C15.5838 12.1596 15.6992 11.9195 15.6989 11.6657C15.6986 11.3739 15.4212 11.0272 14.8664 10.3337L13.5583 8.69851C13.45 8.56315 13.3958 8.49547 13.3573 8.4201C13.3232 8.35324 13.2982 8.28206 13.2831 8.20851C13.2661 8.12561 13.2661 8.03893 13.2661 7.86558V6.09007C13.2661 5.99413 13.2661 5.94616 13.2715 5.89886C13.2763 5.85683 13.2844 5.81524 13.2955 5.77443C13.308 5.7285 13.3258 5.68396 13.3615 5.59488L14.2014 3.49515C14.4464 2.88257 14.5689 2.57629 14.5178 2.33041C14.4731 2.1154 14.3454 1.92672 14.1623 1.80538C13.953 1.66663 13.6232 1.66663 12.9634 1.66663H6.90215C6.24239 1.66663 5.91251 1.66663 5.7032 1.80538C5.52015 1.92672 5.39241 2.1154 5.34773 2.33041C5.29664 2.57629 5.41915 2.88257 5.66418 3.49515L6.50407 5.59488C6.5397 5.68396 6.55752 5.7285 6.57005 5.77443C6.58119 5.81524 6.5892 5.85683 6.59401 5.89886C6.59944 5.94616 6.59944 5.99413 6.59944 6.09007Z"
                stroke={color}
                strokeWidth="1.67"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default Pinned;
